import { CommonModule } from '@angular/common';
import { Component, ElementRef, input, output } from '@angular/core';
import { DxPopupModule } from 'devextreme-angular';

export type VimeoShareActionKey = 'mail' | 'facebook' | 'twitter' | 'tumblr' | 'linkedin';

type VimeoShareAction = {
  key: VimeoShareActionKey;
  label: string;
  iconClass: string;
};

const SOCIAL_SHARE_ACTIONS: readonly VimeoShareAction[] = [
  {
    key: 'mail',
    label: 'Email',
    iconClass: 'dx-icon-agi-envelope',
  },
  {
    key: 'facebook',
    label: 'Facebook',
    iconClass: 'dx-icon-agi-facebook-f',
  },
  {
    key: 'twitter',
    label: 'X',
    iconClass: 'dx-icon-agi-twitter-x',
  },
  {
    key: 'tumblr',
    label: 'Tumblr',
    iconClass: 'dx-icon-agi-tumblr',
  },
  {
    key: 'linkedin',
    label: 'LinkedIn',
    iconClass: 'dx-icon-agi-linkedin-in',
  },
] as const;

@Component({
  selector: 'ag-shr-vimeo-video-share-popup',
  standalone: true,
  imports: [CommonModule, DxPopupModule],
  templateUrl: './vimeo-video-share-popup.component.html',
  styleUrls: ['./vimeo-video-share-popup.component.scss'],
})
export class VimeoVideoSharePopupComponent {
  readonly visibleSig = input(false, { alias: 'visible' });
  readonly containerSig = input<HTMLElement | ElementRef<HTMLElement> | null | undefined>(undefined, {
    alias: 'container',
  });
  readonly isPrivateVideoSig = input(false, { alias: 'isPrivateVideo' });
  readonly privateVideoMessageSig = input('', { alias: 'privateVideoMessage' });
  readonly shareLinkSig = input('', { alias: 'shareLink' });
  readonly copyButtonTextSig = input('Copy', { alias: 'copyButtonText' });

  protected readonly socialShareActions = SOCIAL_SHARE_ACTIONS;

  readonly closeRequested = output<void>();
  readonly copyRequested = output<void>();
  readonly shareRequested = output<VimeoShareActionKey>();

  protected handleClose(): void {
    this.closeRequested.emit();
  }

  protected handleCopy(): void {
    this.copyRequested.emit();
  }

  protected handleHiding(): void {
    this.closeRequested.emit();
  }

  protected resolvePopupTarget(): HTMLElement | Window | string | undefined {
    const container = this.containerSig();

    if (container instanceof ElementRef) {
      return container.nativeElement;
    }

    return container ?? undefined;
  }

  protected shareTo(actionKey: VimeoShareActionKey): void {
    this.shareRequested.emit(actionKey);
  }
}
